module.exports = __webpack_public_path__ + "static/media/maslow-pyramid-1.a0c53565.png";